
import { Vue, Component, Prop } from 'vue-property-decorator';
import LoadMoreHint from '@/features/common/components/LoadMoreHint.vue';
import NoResultsFound from '@/features/common/components/NoResultsFound.vue';

@Component({
  components: {
    LoadMoreHint,
    NoResultsFound,
  },
})
export default class DataTableWrapper extends Vue {
  @Prop({ required: false, default: 0 }) totalItemsCount!: number;

  @Prop({ required: false, default: false }) loading!: boolean;

  @Prop({ required: false, default: false }) isLoadMoreHint!: boolean;

  @Prop({ required: false, default: false }) isFallbackContent!: boolean;
}
